<template>
  <a :href="link" :target="target">
    <div
      class="buttonTap"
      :class="{ disabled: disabled }"
      @click="$emit('click')"
    >
      <div v-show="iconClass !== 'none'">
        <i :class="iconClass" class="mb-3 mt-1"></i>
      </div>
      <div class="buttonTapSlot">
        <slot></slot>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'ButtonTapWithIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconClass: String,
    link: String,
    layout: {
      type: String,
      default: 'horizontal',
    },
    target: {
      type: String,
      default: '_self',
    },
  },
};
</script>

<style scoped lang="scss">
a,
a:hover {
  text-decoration: none;
  color: inherit;
}
p {
  margin-bottom: 0 !important;
}

.buttonTap {
  display: flex;
  gap: 0rem 1.5rem;
  align-items: center;
  border: 1px solid $gray-400;
  border-radius: $border-radius;
  padding: 1rem 1.5rem;
  flex-wrap: wrap;
  cursor: pointer;
  min-height: 100%;
  i {
    font-size: 2rem;
  }
  text-align: left;
}

.buttonTap.disabled {
  border: 1px solid $gray-300;
  background: $gray-100;
  color: $gray-700;

  i {
    color: $gray-600;
  }
}

.buttonTap.disabled:hover {
  border: 1px solid $gray-300;
  background: $gray-100;
  cursor: not-allowed;

  i {
    color: $gray-600;
  }
}

.buttonTap:hover {
  border: 1px solid $primary;
  background: rgba($primary, 0.08);
  //box-shadow: 0 0 0 0.2rem rgba($primary, 0.25);
  //-webkit-box-shadow: 0 0 0 0.2rem rgba(2, 198, 134, 0.25);

  i {
    color: $primary;
  }
}
.buttonTapSlot {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 1rem;
}
</style>
